import {
  Badge,
  Col,
  Drawer,
  Dropdown,
  Popover,
  Row,
  Typography,
  Button,
  Alert,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { useEffect, useState } from "react";
import { IoMenu } from "react-icons/io5";
import { ImageUrl } from "../../config/helper";
import { FaSuitcase, FaMapPin, FaBus } from "react-icons/fa";
import { IoIosNotifications } from "react-icons/io";
import { IoCarSport, IoPin } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdJet } from "react-icons/io";
import { RiWallet3Fill } from "react-icons/ri";
import { FaGift } from "react-icons/fa6";
import { FaAward } from "react-icons/fa";
import { RiSteering2Line } from "react-icons/ri";
import { IoSettingsSharp } from "react-icons/io5";
import ProfileModal from "../../Modals/ProfileModal";
import { useDispatch, useSelector } from "react-redux";
import { NOTIFICATIONS, UPLOADS_URL } from "../../config/constants/api";
import { Get } from "../../config/api/get";
import { setCount } from "../../redux/slice/notificationSlice";
import { GoBellFill } from "react-icons/go";
import socket from "../../config/socket/index.js";

const Header = () => {
  const dispatch = useDispatch();
  const [profileModal, setProfileModal] = useState(false);
  const navigate = useNavigate();
  const notificationsCount = useSelector((state) => state.notification.count);
  const [activeTab, setActiveTab] = useState("");
  const location = useLocation();
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [latestNotifications, setLatestNotifications] = useState(null);
  useEffect(() => {
    getAllNotifications();
  }, []);

  const getAllNotifications = () => {
    Get(NOTIFICATIONS.getAllMyNotifications, token, {
      page: "1",
      limit: "3",
      isRead: false,
    })
      .then((response) => {
        if (response?.status) {
          setLatestNotifications(response?.data?.notifications?.docs);
          dispatch(setCount(response?.data?.unreadCount));
        }
      })
      .catch((err) => {
        console.log("Error fetching notifications ", err);
      });
  };
  useEffect(() => {
    socket.on("rideRequest", (data) => {
      getAllNotifications();
    });
    return () => {
      socket.off("rideRequest");
    };
  }, []);
  useEffect(() => {
    socket.on("rideAccepted", (data) => {
      getAllNotifications();
    });
    return () => {
      socket.off("rideAccepted");
    };
  }, []);
  useEffect(() => {
    // Extract the pathname from the location object
    const currentPath = location.pathname;

    // Set the activeTab state based on the current path
    if (currentPath === "/ride") {
      setActiveTab("RIDE");
    } else if (currentPath === "/recent") {
      setActiveTab("RECENT");
    } else if (currentPath === "/shortcut") {
      setActiveTab("SHORTCUT");
    } else if (currentPath === "/airport") {
      setActiveTab("AIRPORT");
    } else if (currentPath === "/transit") {
      setActiveTab("TRANSIT");
    } else {
      setActiveTab(""); // If none of the above, reset activeTab
    }
  }, [location.pathname]);
  const items = [
    {
      key: "1",
      label: (
        <Link to="/about" className="px-8 font-euclid text-sm font-semibold">
          ABOUT US
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link to="/team" className="px-8 font-euclid text-sm font-semibold">
          OUR TEAM
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link to="/blogs" className="px-8 font-euclid text-sm font-semibold">
          BLOG
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link to="/register" className="px-8 font-euclid text-sm font-semibold">
          PR
        </Link>
      ),
    },
  ];
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const content = (
    <div style={{ width: "350px" }}>
      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>Notifications</h3>
        <Alert
          message={`${notificationsCount} New`}
          type="success"
          style={{ fontSize: "12px", padding: "2px 10px", color: "green" }}
        />
      </div>
      <hr
        style={{
          borderLeft: "none",
          borderBottom: "none",
          borderRight: "none",
          borderTop: "1px solid rgb(0 0 0 / 15%)",
        }}
      />
      <div style={{ height: "250px", overflow: "auto" }}>
        {latestNotifications &&
          latestNotifications.length > 0 &&
          latestNotifications.map((item) => {
            return (
              <div
                style={{
                  padding: 10,
                  minHeight: "100px",
                  borderBottom: "1px solid #dadada",
                  marginBottom: "5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate('/notification');
                }}
              >
                <Row
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Col xs={4}>
                    <div
                      style={{
                        // padding: "10px 10px 10px 10px",

                        display: "flex",
                        width: "40px",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "40px",
                        backgroundColor: "#385790",
                        borderRadius: "5px",
                      }}
                    >
                      <GoBellFill
                        style={{
                          fontSize: "20px",
                          color: "white",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  </Col>
                  <Col xs={18}>
                    <Typography.Title
                      className="fontFamily1"
                      style={{ fontSize: "14px", color: "black", margin: 0 }}
                    >
                      {item.title}
                    </Typography.Title>

                    <Typography.Text
                      className="fontFamily1"
                      style={{ fontSize: "12px", color: "black", margin: 0 }}
                    >
                      {item?.content?.slice(0, 100)}{" "}
                      {item.content.length > 100 && "..."}
                    </Typography.Text>
                  </Col>
                </Row>
              </div>
              // <></>
            );
          })}
      </div>

      <hr
        style={{
          borderLeft: "none",
          borderBottom: "none",
          borderRight: "none",
          borderTop: "1px solid rgb(0 0 0 / 15%)",
        }}
      />

      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Button onClick={() => navigate("/notification")} type="link">
          View All
        </Button>
      </div>
    </div>
  );
  return (
    <div>
      <Row
        justify="center"
        className="bg-[#1b1b1b] border-b-2 border-gray-200 max-sm:py-4"
      >
        <Col xxl={20} md={22} sm={22} xs={22}>
          <Row justify="center">
            <Col lg={2} sm={4} xs={4} className="self-center">
              <img
                src={ImageUrl("logo.png")}
                alt="logo"
                // className="2xl:mb-[-40px]"
                className="py-2"
              />
            </Col>
            <Col lg={0} sm={8} xs={8}></Col>
            <Col lg={16} sm={0} xs={0} className="self-center">
            <Row justify="center" className="py-8">
              <div className="flex justify-center items-center">
                <Link
                  to="/"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "HOME" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4`}
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                    activeTab === "RIDE" ? "text-customGold" : "text-white"
                  } max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4`}
                >
                  About Us
                </Link>
                <Link
                  to="/signIn"
                  className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                  Our Services
                </Link>
                <Link
                  to="/signIn"
                  className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                  Memberships
                </Link>
                <Link
                  to="/signIn"
                  className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                  Our Models
                </Link>
                <Link
                  to="/signIn"
                  className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                  Blogs
                </Link>
                <Link
                  to="/contact"
                  className="text-sm font-euclid cursor-pointer text-white hover:text-customGold max-2xl:text-xs text-center px-5 max-desktop:px-4 max-lg:px-4"
                >
                 Contact Us
                </Link>
                {/* <Dropdown
                  menu={{
                    items,
                  }}
                  placement="bottom"
                >
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className={`text-sm font-euclid cursor-pointer hover:text-customGold ${
                      activeTab === "ABOUT" ? "text-customGold" : "text-white"
                    } max-2xl:text-sm text-end flex px-8 max-desktop:px-6 max-lg:px-4`}
                  >
                    ABOUT
                    <FaChevronDown className="ml-1 mt-1" />
                  </a>
                </Dropdown> */}
              </div>
            </Row>
            </Col>
            <Col lg={6} sm={12} xs={12} className="self-center">
              <div className="flex justify-end items-center text-customGray mr-2 hover:text-customGold">
                {/* <IoIosNotifications
                  size={28}
                  className="text-customGray hover:text-customGold cursor-pointer"
                  onClick={() => navigate("/notification")}
                /> */}
                <Popover
                  content={content}
                  placement="bottomRight"
                  arrow={false}
                  className="headerPopover"
                >
                  <Badge
                    count={notificationsCount}
                    style={{
                      backgroundColor: "red",
                      padding: "0",
                      minWidth: "15px",
                      height: "15px",
                      fontSize: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <GoBellFill
                      style={{
                        fontSize: "25px",
                        color: "#000",
                        cursor: "pointer",
                      }}
                    />
                  </Badge>
                </Popover>
                <Link
                  to="/register"
                  className=" font-euclid cursor-pointer text-customGray hover:text-customGold text-sm text-center mx-4 flex justify-center font-semibold max-tablet:hidden"
                >
                  <FaSuitcase className="mr-1 self-center" size={24} />
                  <p className="mt-1">My Trips</p>
                </Link>
                <div className="font-euclid cursor-pointer text-customGray text-sm text-center flex mx-2">
                  <img
                    src={UPLOADS_URL + userData?.image}
                    className="h-[50px] w-[50px] max-sm:h-[40px] max-sm:w-[40px] rounded-full object-cover object-center"
                    onClick={() => setProfileModal(true)}
                  />{" "}
                  <Dropdown
                    menu={{
                      items,
                    }}
                    placement="bottom"
                    className=""
                  >
                    <FaChevronDown className="ml-2 mt-5 max-sm:mt-3 max-sm:ml-1 hover:text-customGold" />
                  </Dropdown>
                </div>
                <div onClick={showDrawer} className="tablet:hidden">
                  <IoMenu size={24} className="text-customGray" />
                </div>
              </div>
            </Col>
            <Drawer title="Menu" onClose={onClose} open={open}>
              <Link
                to="/ride"
                className=" font-euclid cursor-pointer text-customGray hover:text-customGold text-sm font-semibold text-center flex"
              >
                <IoCarSport size={24} className="mr-1" />
                <p>Ride</p>
              </Link>

              <Link
                to="/recent"
                className=" font-euclid cursor-pointer text-customGray hover:text-customGold text-sm font-semibold text-center flex my-2"
              >
                <FaLocationDot size={24} className="mr-1" />
                <p>Recent</p>
              </Link>
              <Link
                to="/shortcut"
                className=" font-euclid cursor-pointer text-customGray hover:text-customGold text-sm font-semibold text-center flex "
              >
                <FaMapPin size={24} className="mr-1" />
                <p>Shortcuts</p>
              </Link>
              <Link
                to="/airport"
                className=" font-euclid cursor-pointer text-customGray hover:text-customGold text-sm font-semibold text-center flex my-2"
              >
                <IoMdJet size={24} className="mr-1" />
                <p>Airports</p>
              </Link>
              <Link
                to="/transit"
                className=" font-euclid cursor-pointer text-customGray hover:text-customGold text-sm font-semibold text-center flex"
              >
                <FaBus size={24} className="mr-1" />
                <p>Transit</p>
              </Link>
              <Link
                to="/"
                className=" font-euclid cursor-pointer text-customGray hover:text-customGold text-sm font-semibold text-center flex my-2"
              >
                <FaSuitcase size={24} className="mr-1" />
                <p>My Trips</p>
              </Link>
            </Drawer>
          </Row>
        </Col>
      </Row>
      {profileModal && (
        <ProfileModal
          profileModal={profileModal}
          setProfileModal={setProfileModal}
        />
      )}
    </div>
  );
};

export default Header;
